import { createStyles, makeUiStyles, Theme } from '../../styles/styles';
import { fontSize, fontText, hexToRgbA, StylesIndexInjections } from 'common-react';
import { focusStyle, fieldBoxShadow, focusStyleByBoxShadow } from '../../styles/mixins';

export default makeUiStyles((theme: Theme) => createStyles({
  flag: {
    flexShrink: 0,
  },
  countrySelectOption: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    font: fontText('normal', fontSize.base, 24),
  },
  searchableFormControl: {
    width: '100%',
    '& .MuiFormLabel-root': {
      marginBottom: 4
    },
    '& .MuiInput-underline:before': {
      borderBottom: 'none',
    },
  },
  autocompleteInput: {
    font: fontText('normal', fontSize.base, 24),
    border: `1px solid ${theme.color.greys[40]}`,
    borderRadius: 2,
    padding: '10px 16px !important',
    minHeight: 56,
    '&.Mui-disabled': {
      backgroundColor: theme.color.greys[20],
      color: theme.color.functional.disabled,
    },
    '& .MuiInputBase-input': {
      padding: '0 !important',
      marginLeft: 8,
    },
  },
  autocompleteOption: {
    font: fontText('normal', fontSize.base, 24),
    color: theme.color.greys[80],
    padding: 16,
    border: `1px solid ${theme.color.greys[15]}`,
    borderRadius: 8,
    '&:hover, &[data-focus="true"], &[aria-selected="true"]': {
      boxShadow: fieldBoxShadow(theme).bs2,
      backgroundColor: theme.color.greys[0],
    },
  },
  autocompletePaper: {
    border: `1px solid ${theme.color.greys[15]}`,
    marginTop: 8,
    borderRadius: 8,
    backgroundColor: theme.color.greys[0],
    boxShadow: fieldBoxShadow(theme).bs3,
  },
  autocompleteListbox: {
    padding: '16px 4px',
    maxHeight: 300,
  },
  countrySelectWrapper: {
    width: '100%',
    marginBottom: 28,
    '& .country_select': {
      '&__placeholder': {
        font: fontText('normal', fontSize.base, 24),
        color: theme.color.greys[60],
      },
      '&__input': {
        paddingLeft: 24,
      },
      '&__control': {
        borderRadius: 2,
        maxWidth: 310,
        backgroundColor: theme.color.greys[0],
        padding: '12px 16px',
        maxHeight: 56,
        borderColor: theme.color.greys[40],
        borderWidth: 1,
        boxShadow: 'none',
        '&--is-disabled': {
          backgroundColor: theme.color.greys[40],
        },
        '&--is-focused': {
          boxShadow: `0 0 0 2px ${theme.color.violets[50]}`,
          outline: 'none',
        },
        '&:hover': {
          borderColor: 'transparent',
          boxShadow: `0 0 0 2px ${theme.color.violets[50]}`,
        },
        '&--menu-is-open': {
          '& .country_select__dropdown-indicator': {
            transform: 'rotate(180deg)',
          },
        }
      },
      '&__value-container': {
        paddingLeft: 0,
      },
      '&__single-value, &__option': {
        font: fontText('normal', fontSize.base, 24),
        color: theme.color.greys[60],
      },
      '&__single-value': {
        margin: 0,
        '&--is-disabled': {
          color: theme.color.functional.disabled,
        },
      },
      '&__dropdown-indicator': {
        position: 'relative',
        '& svg': {
          display: 'none',
        },
      },
      '&__indicator': {
        '&-separator': {
          display: 'none',
        },
      },
      '&__menu': {
        background: theme.color.greys[0],
        zIndex: 1000,
        border: `1px solid ${theme.color.greys[15]}`,
        boxSizing: 'border-box',
        boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
        borderRadius: 8,
        maxWidth: 310,
      },
      '&__option': {
        '&:hover': {
          background: theme.color.greys[0],
        },
        '&--is-selected, &--is-focused': {
          backgroundColor: theme.color.greys[0],
        },
        '&--is-focused': {
          ...focusStyle(theme, -2)
        },
      }
    },
    '&.Mui-focusVisible': {
      '& .country_select': {
        '&__control': {
          ...focusStyleByBoxShadow(theme),
        },
      },
    },
  },
  disabledIcon: {
    color: hexToRgbA(theme.color.oranges[50], 0.4),
  },
}), { name: 'DropdownCountry', index: StylesIndexInjections.UI_MOLECULES });
